import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class SiteConfigModel extends BaseModel {

    constructor(source?: SiteConfigModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._siteConfigID = 0;
        }
    }

// private properties
    _siteConfigID: number = 0;
    _eventName: string | null = null;

// public properties
    public get siteConfigID(): number
    {
        return this._siteConfigID;
    }
    public set siteConfigID(v: number)
    {
        if (v !== this._siteConfigID)
        {
            this._siteConfigID = v;
            this.propertyChanged.emit(new propertyChangedArguments("siteConfigID", this));
        }
    }

    public get eventName(): string | null
    {
        return this._eventName;
    }
    public set eventName(v: string | null)
    {
        if (v !== this._eventName)
        {
            this._eventName = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventName", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: SiteConfigModel): void {
        if (source == null) return;
        this._siteConfigID = source.siteConfigID;
        this._eventName = source.eventName;
    }


}
